module.exports = __webpack_public_path__ + "img/Wp_2050.c8a79770.png";